import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, role }) {
  const { user, actAs } = useAuth();

  if (user === undefined)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a]">
        <Loader2 className="h-6 w-6 animate-spin text-[#ff3b30]" />
      </div>
    );
  if (user === null) return <Navigate to="/login" replace />;

  // Admins impersonating an agent may access agent-role routes.
  const adminActingAsAgent = role === "agent" && user.role === "admin" && actAs;
  if (role && user.role !== role && !adminActingAsAgent)
    return <Navigate to={user.role === "admin" ? "/lender" : "/dashboard"} replace />;
  return children;
}
